import { tooltip, interaction, animation, theme, scale, annotation } from '../../adaptor/common';
import { flow } from '../../utils';
import { basicFunnel } from './geometries/basic';
import { compareFunnel } from './geometries/compare';
import { dynamicHeightFunnel } from './geometries/dynamic-height';
/**
 *
 * 各式漏斗图geometry实现细节有较大不同,
 * 1. 普通漏斗图：interval.shape('funnel')
 * 2. 对比漏斗图：分面
 * 3. 动态高度漏斗图：polypon
* /

/**
 * geometry处理
 * @param params
 */

function geometry(params) {
  var options = params.options;
  var compareField = options.compareField,
      dynamicHeight = options.dynamicHeight;

  if (compareField) {
    return compareFunnel(params);
  }

  if (dynamicHeight) {
    return dynamicHeightFunnel(params);
  }

  return basicFunnel(params);
}
/**
 * meta 配置
 * @param params
 */


export function meta(params) {
  var _a;

  var options = params.options;
  var xAxis = options.xAxis,
      yAxis = options.yAxis,
      xField = options.xField,
      yField = options.yField;
  return flow(scale((_a = {}, _a[xField] = xAxis, _a[yField] = yAxis, _a)))(params);
}
/**
 * 坐标轴
 * @param params
 */

function axis(params) {
  var chart = params.chart;
  chart.axis(false);
  return params;
}
/**
 * legend 配置
 * @param params
 */


function legend(params) {
  var chart = params.chart,
      options = params.options;
  var legend = options.legend;

  if (legend === false) {
    chart.legend(false);
  } else {
    chart.legend(legend); // TODO FIX: legend-click 时间和转化率组件之间的关联
  }

  return params;
}
/**
 * 漏斗图适配器
 * @param chart
 * @param options
 */


export function adaptor(params) {
  return flow(geometry, meta, axis, tooltip, interaction, legend, animation, theme, annotation())(params);
}